// --------------------- Import Globais ---------------------
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// --------------------- Import Antd-Design ---------------------
import {
  Modal,
  Form,
  Input,
  Radio,
  RadioChangeEvent,
  DatePicker,
  Select,
  Skeleton,
} from "antd";

// --------------------- Import Styles ---------------------
import { formStyle, layout, Title } from "../styles";

// --------------------- Import Hooks ---------------------
import { useCadastrarPostagem } from "../hooks/useCadastrarPostagem";
import { useBuscarEmpreendimentos } from "../../ViewGerenciarPropriedadeUsuario/hooks/useBuscarEmpreendimentos";
// --------------------- Import Uteis ---------------------
import { useError } from "../../../uteis/mensagens/useError";
import { useSuccess } from "../../../uteis/mensagens/useSuccess";

// --------------------- Import dayJS ---------------------
import dayjs from "dayjs";
import "dayjs/locale/pt-br"; // Caso queira suportar o formato em português
import customParseFormat from "dayjs/plugin/customParseFormat";

import PhoneInput from "react-phone-input-2";
import { useBuscarFonte } from "../hooks/useBuscarFonte";
import { useMessage } from "../../../uteis/mensagens/useMessage";

interface ModalAdicionarProps {
  isModalOpen: boolean;
  handleFechar: () => void;
  setSuccess: (msg: string) => void;
  setError: (msg: string) => void;
}

export default function ModalAdicionar({
  isModalOpen,
  handleFechar,
  fetch,
}: any) {
  const [formCadastrarPostagem] = Form.useForm();

  const { isLoading: isLoadingEmpreendimento, empreendimento } =
    useBuscarEmpreendimentos(isModalOpen);

  const { fontes } = useBuscarFonte(isModalOpen);

  dayjs.extend(customParseFormat);

  // UseStates necessários para armazenar os dados que irão ser atualizados
  const [alugar, setAlugar] = useState<number>();
  const [trocar, setTrocar] = useState<number>();
  const [compra, setCompra] = useState<number>();
  const [venda, setVenda] = useState<number>();
  const [tipoInteresse, setTipoInteresse] = useState<string>();
  const [phone, setPhone] = useState("");

  // Função que armazena o dado selecionado do alugar
  const alugarChange = (e: RadioChangeEvent) => {
    setAlugar(e.target.value);
  };

  // Função que armazena o dado selecionado da troca
  const trocarChange = (e: RadioChangeEvent) => {
    setTrocar(e.target.value);
  };

  // Função que armazena o dado selecionado da compra
  const compraChange = (e: RadioChangeEvent) => {
    setCompra(e.target.value);
  };

  // Função que armazena o dado selecionado da venda
  const vendaChange = (e: RadioChangeEvent) => {
    setVenda(e.target.value);
  };
  // Função que armazena o dado selecionado do alugar
  const tipoInteresseChange = (e: RadioChangeEvent) => {
    setTipoInteresse(e.target.value);
  };
  const handlePhoneChange = (value: string) => {
    setPhone(value);
  };

  // Estado inicial de dos dados Postagem que serão atualizados
  const [postagemData, setPostagemData] = useState<any>({});

  // Função que armazena os dados alterados de Apartamento
  const postagemChange = (changedValues: Partial<any>, allValues: any) => {
    setPostagemData(allValues);
  };

  const {
    cadastrar,
    isLoading,
    error,
    success,
    warning,
    resetWarning,
    resetError,
    resetSuccess,
  } = useCadastrarPostagem();

  // Exibe a Mensagem
  const { showSuccess, showError, showWarning, contextHolder } = useMessage();

  // Estados para controlar as exibições
  const [errorDisplayed, setErrorDisplayed] = useState(false);
  const [successDisplayed, setSuccessDisplayed] = useState(false);
  const [warningDisplayed, setWarningDisplayed] = useState(false);
  // Hook de navegação do React Router
  const navigate = useNavigate();

  useEffect(() => {
    if (isModalOpen) {
      // Exibe a mensagem de sucesso
      if (success && !successDisplayed) {
        showSuccess(success);
        setSuccessDisplayed(true);
        fetch?.();
        handleFechar();
        formCadastrarPostagem.resetFields(); // Limpa os campos do formulário após o sucesso
        setTimeout(() => {
          resetSuccess();
          setSuccessDisplayed(false);
        }, 2000);
      }

      // Exibe a mensagem de erro
      if (error && !errorDisplayed) {
        showError(error);
        setErrorDisplayed(true);

        // Limpa estado de error após 3 segundos
        setTimeout(() => {
          setErrorDisplayed(false);
          resetError();
        }, 3000);
      }
      if (warning && !warningDisplayed) {
        showWarning(warning);
        setWarningDisplayed(true);

        // Limpa estado de error após 3 segundos
        setTimeout(() => {
          setWarningDisplayed(false);
          resetWarning();
        }, 3000);
      }
    } else {
      // Reseta os estados ao fechar o modal
      setSuccessDisplayed(false);
      setErrorDisplayed(false);
      setWarningDisplayed(false);
    }
  }, [
    isModalOpen,
    success,
    error,
    warning,
    showWarning,
    showSuccess,
    showError,
    resetError,
    resetWarning,
    warningDisplayed,
    errorDisplayed,
    successDisplayed,
    fetch,
  ]);

  /* eslint-disable no-template-curly-in-string */ // Constante que válida os campos de todos os  formulário
  const validarFormulario = {
    required: "${label} é necessário!",
  };
  /* eslint-enable no-template-curly-in-string */

  return (
    <>
      <Modal
        open={isModalOpen}
        onCancel={handleFechar}
        cancelText="Cancelar"
        okText="Cadastrar"
        onOk={() => {
          const nome = formCadastrarPostagem.getFieldValue("nome");
          const celular = phone?.trim();
          const fonte = formCadastrarPostagem.getFieldValue("fonte");
          const idEmpreendimento = formCadastrarPostagem.getFieldValue("idEmpreendimento");
          const tipoInteresse = formCadastrarPostagem.getFieldValue("tipoInteresse");
          const aluguel = formCadastrarPostagem.getFieldValue("aluguel");
          const troca = formCadastrarPostagem.getFieldValue("troca");
          const compra = formCadastrarPostagem.getFieldValue("compra");
          const venda = formCadastrarPostagem.getFieldValue("venda");
          const dataDivulgacao = formCadastrarPostagem.getFieldValue("dataDivulgacao");
          const dataIni = formCadastrarPostagem.getFieldValue("dataIni");
          const dataFim = formCadastrarPostagem.getFieldValue("dataFim");

          // ✅ 1. Pelo menos um entre nome ou celular
          if (!nome && (!celular || celular === "")) {
            showWarning("Informe pelo menos o nome ou o celular para continuar.");
            return;
          }

          // ✅ 2. Campos obrigatórios individuais
          if (!fonte) {
            showWarning("Selecione a fonte da postagem.");
            return;
          }

          if (!idEmpreendimento) {
            showWarning("Selecione o empreendimento.");
            return;
          }

          if (!tipoInteresse) {
            showWarning("Selecione o tipo de interesse (Procura ou Disponibiliza).");
            return;
          }

          if (aluguel === undefined) {
            showWarning("Informe se deseja alugar.");
            return;
          }

          if (troca === undefined) {
            showWarning("Informe se deseja trocar.");
            return;
          }

          if (compra === undefined) {
            showWarning("Informe se deseja comprar.");
            return;
          }

          if (venda === undefined) {
            showWarning("Informe se deseja vender.");
            return;
          }

          if (!dataDivulgacao) {
            showWarning("Informe a data de divulgação.");
            return;
          }

          if (!dataIni) {
            showWarning("Informe a data de início.");
            return;
          }

          if (!dataFim) {
            showWarning("Informe a data de fim.");
            return;
          }

          // ✅ Se passou em todas as críticas, envia
          cadastrar(postagemData);
        }}


        confirmLoading={isLoading}
        okButtonProps={{
          style: {
            backgroundColor: "#003644",
            borderColor: "#003644",
            color: "white",
          }, // Botão "Ativar" com fundo verde
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: "#f44336",
            borderColor: "#f44336",
            color: "white",
          }, // Botão "Cancelar" com fundo vermelho
        }}
      >
        {isLoadingEmpreendimento && <Skeleton />}
        {!isLoadingEmpreendimento && (
          <>
            <>{contextHolder}</>

            <Form
              {...layout}
              form={formCadastrarPostagem}
              onValuesChange={(changedValues, allValues) =>
                postagemChange(changedValues, allValues)
              }
              name="postagem"
              style={formStyle}
              validateMessages={validarFormulario}
            >
              <Title>Adicionar Postagem</Title>

              <Form.Item name={["nome"]} label="Lead " className="formItems">
                <Input />
              </Form.Item>
              <Form.Item
                name="celular"
                label="Celular"
                className="formItems"
                getValueFromEvent={(value) => value} // Garante que o valor do PhoneInput seja capturado corretamente
              >
                <PhoneInput
                  country={"br"}
                  value={phone}
                  onChange={handlePhoneChange}
                  placeholder="Digite seu telefone"
                  inputClass="phone-input"
                />
              </Form.Item>
              <Form.Item
                name={["idEmpreendimento"]}
                label="Empreendimento "
                className="formItems"
              >
                <Select placeholder="Empreendimento">
                  {empreendimento.map((emp, index) => (
                    <Select.Option key={emp.id} value={emp.id}>
                      {emp.nome}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name={["fonte"]} label="Fonte " className="formItems">
                <Select placeholder="Fonte">
                  {fontes.map((fonte: any, index: any) => (
                    <Select.Option key={fonte.id} value={fonte.nome}>
                      {fonte.nome}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name={["grupo"]} label="Grupo " className="formItems">
                <Input />
              </Form.Item>
              <Form.Item
                name={["dataDivulgacao"]}
                label="Data Divulgação "
                className="formItems"
              >
                <DatePicker format="DD/MM/YYYY" />
              </Form.Item>
              <Form.Item
                name={["tipoInteresse"]}
                label="Tipo Interesse "
                className="formItems"
              >
                <Radio.Group
                  onChange={tipoInteresseChange}
                  value={tipoInteresse}
                >
                  <Radio value={"DISPONIBILIZA"}>Disponibiliza</Radio>
                  <Radio value={"PROCURA"}>Procura</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name={["aluguel"]}
                label="Alugar "
                className="formItems"
              >
                <Radio.Group onChange={alugarChange} value={alugar}>
                  <Radio value={0}>Não</Radio>
                  <Radio value={1}>Sim</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item name={["troca"]} label="Trocar " className="formItems">
                <Radio.Group onChange={trocarChange} value={trocar}>
                  <Radio value={0}>Não</Radio>
                  <Radio value={1}>Sim</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name={["compra"]}
                label="Compra "
                className="formItems"
              >
                <Radio.Group onChange={compraChange} value={compra}>
                  <Radio value={0}>Não</Radio>
                  <Radio value={1}>Sim</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item name={["venda"]} label="Venda " className="formItems">
                <Radio.Group onChange={vendaChange} value={venda}>
                  <Radio value={0}>Não</Radio>
                  <Radio value={1}>Sim</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name={["dataIni"]}
                label="Data Inicio "
                className="formItems"
              >
                <DatePicker format="DD/MM/YYYY" />
              </Form.Item>
              <Form.Item
                name={["dataFim"]}
                label="Data Fim "
                className="formItems"
              >
                <DatePicker format="DD/MM/YYYY" />
              </Form.Item>
            </Form>
          </>
        )}
      </Modal>
    </>
  );
}
